import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { mainTemplate, layerGroupTemplate, buscarTemplate, polygonGroupTemplate, 
	uploadPolygonTemplate, updateHTMLtemplates } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import L from 'leaflet';
import "leaflet-draw/dist/leaflet.draw.css";
import 'leaflet-draw';

import * as shapefile from "shapefile";
import dissolve from 'geojson-dissolve';
import { bbox } from '@turf/turf';
import { parse } from 'wkt';
//import { nanoid } from 'nanoid/non-secure';
import { str as CRC32str } from 'crc-32';

import { Datos, Sesion, Layers, obtenerURL, cargarURL } from '../main.js';
import { Mimapa, obtenerConfigMapaBase, actualizarMapaBase } from './map.js';
import { incluirPoligonoSP, borrarPoligonoSP, cambiarSeleccionParcelaSP } from './plots.js';
import { selRegion, ajustarColorRegiones, repintarRegiones } from './regions.js';
import { handlerFiltrarTaxon, handlerAjustarFiltroTaxon, handlerNombreCientifico } from './taxons.js';
import { prepararDescarga } from './download.js';
import { lanzarTour } from './shepherd.js';
import { getLiteral, getPreferredLang, configurarModal } from './util.js';
import { sendEvent } from './events.js';


let drawControl;

function cargarPaginaPrincipal() {
	// inicializo con el nombre científico
	const obj = { nomci: Sesion.nomci };
	const html = Mustache.render(mainTemplate, obj);
	document.getElementById("mipagina").innerHTML = html;	
	// inicializo título de la página
	document.title = "App - " + getLiteral(dict.title);
	
	// handler de los botones de los popups (funciona incluso si los popups se añaden dinámicamente)
	document.addEventListener("click", function(event) {
    	// para las parcelas miro la clase "plotpopup"
    	if (event.target.classList.contains("plotpopup")) {
	        const piri = event.target.getAttribute("iri"); // extraigo el id de parcela
        	cambiarSeleccionParcelaSP(piri, false); // selecciono (igual que con doble click)
    	}
    	else if (event.target.classList.contains("regpopup")) { // regiones
	        const riri = event.target.getAttribute("iri"); // extraigo el id de la región
        	selRegion(riri); // selecciono (igual que con doble click)
    	}
    	else if (event.target.classList.contains("polipopup")) { // polígonos
    		 // extraigo el índice del polígono
	        const piri = event.target.getAttribute("iri");
	        const ind = Number(piri.substring(4, piri.length)); // será poliXXXX
        	borrarPoligonoSP(ind); // selecciono (igual que con doble click)
    	}  	
	});
	
	// handler del botón de descargar
	document.getElementById('botdescargar').addEventListener('click', prepararDescarga);
	
	// handler de taxón
	document.getElementById('bot_taxones').addEventListener('click', handlerFiltrarTaxon);
	
	// handler ajustar_filtro plantae
	document.getElementById('filter-plantae').addEventListener('click', handlerAjustarFiltroTaxon);
	
	// handler del nombre científico
	document.getElementById('checknomci').addEventListener('change', handlerNombreCientifico);
	
	// handler del radio del ifn
	document.querySelectorAll('input[type=radio][name=ifnradio]').forEach(function(radio) {
		radio.addEventListener('change', function() {
			// Save the value of ifn
			Sesion.estado.ifn = this.getAttribute('id');
			
			// selección edición ifn
			sendEvent( 'select_content', { content_type: 'edition_' + Sesion.estado.ifn } );

			// Clear the content of the element with id "taxones_block"
			// as the taxonomy will change depending on the IFN version
			// (the content will be regenerated when the taxon button is pressed)
			document.getElementById("taxones_block").innerHTML = "";

			// Adjust the URL
			history.replaceState(Sesion.estado, "", obtenerURL());
			
			// y cierro cualquier popup que hubiera
			Mimapa.closePopup();

			// Load the URL (this will adjust the taxon filters)
			cargarURL();
		});
	});
	
	// handler del radio AND / OR de los taxones
	document.querySelectorAll('input[type=radio][name=btnradioandor]').forEach(function(radio) {
		radio.addEventListener('change', function() {
			// actualizo el valor de Sesion.taxonAnd
			Sesion.taxonAnd = this.getAttribute('id') === "and";
			
			// selección taxón and/or
			sendEvent( 'select_content', { content_type: 'taxon_and_' + Sesion.taxonAnd } );

			// Adjust the URL
			history.replaceState(Sesion.estado, "", obtenerURL());

			// Load the URL (this will adjust the taxon filters)
			cargarURL();
		});
	});
	
	/// handlers idioma
	document.querySelectorAll('.lang').forEach(function(link) {
		link.addEventListener('click', function(event) {
			event.preventDefault(); // Prevent the default behavior of the hyperlink
			// recojo idioma y guardo
			const lang = event.target.getAttribute("tag");
			localStorage.setItem('lang', lang);		
			// selección idioma
			sendEvent( 'select_content', { content_type: 'lang_' + lang } );		
			// actualizo plantillas HTML
			updateHTMLtemplates();
			// actualizo etiquetas
			actualizarEtiquetasIdioma();
			// cargo la URL para acabar de rehacer las etiquetas de popups, botones y demás
			cargarURL();
		});
	});
	
	// handler inicio
	document.querySelector('.home').addEventListener('click', function(event) {
		event.preventDefault(); // Prevent the default behavior of the hyperlink
		// Redirect to the landing page
		window.location.href = getLiteral(dict.homelocrel); //'..';     
	});
}

// BOTONES LATERALES MAPA
function cargarBotonesMapa() {
	
	// BOTÓN BUSCAR LOCALIDAD
	const controlBuscar = L.Control.extend({
		options: {
			position: 'topright'//'bottomright'
		},
		onAdd: function (map) {
			// preparo contenedor para el control de las capas
			const container = L.DomUtil.create('div', "leaflet-bar leaflet-control btn-toolbar div-buscar d-none");
			container.setAttribute("role", "toolbar");
			return container;
		}
	});
	// instancio el control
	const cb = new controlBuscar();
	// incluyo el control en el mapa
	Mimapa.addControl(cb);
	// incluyo el contenido boton buscar
	incluirContenidoBotonBuscar();	
	
	
	// BOTÓN TOUR
	const controlTour = L.Control.extend({
		options: {
			position: 'bottomright'
		},
		onAdd: function (map) {
			// preparo contenedor para el control del tour
			const container = L.DomUtil.create('div', "leaflet-bar leaflet-control div-tour");
			
			// link tour
			const lt = L.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single tour", container);
			lt.title = getLiteral(dict.tourTitle13);
			lt.href = "#";
			lt.setAttribute("role", "button");
			L.DomUtil.create('span', 'bi bi-question-lg', lt);
			
			// listener tour
			lt.addEventListener('click', function(e) {
				e.preventDefault(); // Prevent the default behavior of the hyperlink				
				lanzarTour();
			});
			
			return container;
		}
	});		
	// instancio el control
	const cbt = new controlTour();
	// incluyo el control en el mapa
	Mimapa.addControl(cbt);
	
	
	// BOTÓN POLÍGONO con Leaflet Draw
	// inicialmente escondido, sólo se muestra cuando se pincha "dibujar"
	const ldo = {
		position: 'bottomright',
		draw: {
			polyline: false,
			polygon: {
				allowIntersection: false, // Restricts shapes to simple polygons
				drawError: {
					//color: '#e1e100', // Color the shape will turn when intersects
					message: getLiteral(dict.errorPolygon)
				},
				shapeOptions: {
					//color: '#bada55'
					fillColor: config.colores[config.colregselind][3], // color de relleno  
					weight: 2,
					opacity: 1,
					color: config.colores[config.colregselind][4],
					dashArray: '1',
					fillOpacity: 0.4
				}
			},
			circle: false, // Turns off this drawing tool
			rectangle: false,
			marker: false,
			circlemarker: false
		},
		edit: false
	};    
	drawControl = new L.Control.Draw(ldo);
	Mimapa.addControl(drawControl);
	Mimapa.on(L.Draw.Event.CREATED, async function (e) {
		// actualizo flag
		Sesion.poligonero = false;
		// actualizo aspecto botón (sin pulsar)
		document.querySelector(".dibupoli").removeAttribute("style");
		document.querySelector(".dibupoli span").removeAttribute("style");
    	// muestro botón collapsible y escondo la herramienta de dibujo
		document.querySelector(".div-poli").classList.remove("d-none");
		document.querySelector(".leaflet-draw").classList.add("d-none");
		// añado el polígono a la capa de polígonos	
		e.layer.addTo(Layers.polis);
		// incluyo el polígono		
		await incluirPoligonoSP(e.layer);
	});
	// cambio icono polígono
	document.querySelector(".leaflet-draw-draw-polygon").innerHTML = '<span class="bi bi-pentagon-fill"></span>';
	// añado clase inicial "polygon"
	document.querySelector(".leaflet-draw-draw-polygon").classList.add("dibupoli");
	// añado clase inicial "d-none" para que no se vea inicialmente (NUEVO)
	document.querySelector(".leaflet-draw").classList.add("d-none");
	// llamo a actualizar las etiquetas de Leaflet Draw
	actualizarEtiquetasLDraw();
	// listener botón
	document.querySelector(".dibupoli").addEventListener('click', function(e) {
		// cojo ref al botón de cancelar
		//let cancelAnchor = $('ul.leaflet-draw-actions').find('li:eq(2) a');	
		const cancelAnchor = document.querySelector('ul.leaflet-draw-actions').querySelector('li:nth-child(3) a');
		// cambio el flag de poligonero
		Sesion.poligonero = !Sesion.poligonero;	
		if (Sesion.poligonero) {
			// muestro tostada
			document.getElementById('mitostadaBody').innerHTML = getLiteral(dict.polygonToast);
			const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
			tostada.show();
			// actualizo aspecto botón (pulsado)
			document.querySelector(".dibupoli").setAttribute("style", "background-color: #6c757d;");
			document.querySelector(".dibupoli span").setAttribute("style", "color: white;");
			// pongo listener para que quede bien el flag de poligonero
			cancelAnchor.addEventListener('click', function(event) {
				Sesion.poligonero = false;
				// actualizo aspecto botón (sin pulsar)
        		document.querySelector(".dibupoli").removeAttribute("style");
    			document.querySelector(".dibupoli span").removeAttribute("style");
    			// muestro botón collapsible y escondo la herramienta de dibujo
				document.querySelector(".div-poli").classList.remove("d-none");
				document.querySelector(".leaflet-draw").classList.add("d-none");
			});
		}
		else  // llamo a cancelar
			cancelAnchor.click();
	});	
	
	// BOTÓN DIBUJAR/SUBIR POLÍGONO (se esconde si se está dibujando...)
	const controlBotonPoli = L.Control.extend({
		options: {
			position: 'bottomright'
		},
		onAdd: function (map) {
			// preparo contenedor para el control de las capas
			const container = L.DomUtil.create('div', "leaflet-bar leaflet-control btn-toolbar div-poli");
			container.setAttribute("role", "toolbar");
			return container;
		}
	});
	// instancio el control
	const cbp = new controlBotonPoli();
	// incluyo el control en el mapa
	Mimapa.addControl(cbp);
	// incluyo el contenido boton poli
	incluirContenidoBotonPoli();
	
	
	// BOTÓN CAPAS DEL MAPA
	const controlBotonLayers = L.Control.extend({
		options: {
			position: 'bottomright'
		},
		onAdd: function (map) {
			// preparo contenedor para el control de las capas
			const container = L.DomUtil.create('div', "leaflet-bar leaflet-control btn-toolbar div-layers");
			container.setAttribute("role", "toolbar");
			return container;
		}
	});
	// instancio el control
	const cbl = new controlBotonLayers();
	// incluyo el control en el mapa
	Mimapa.addControl(cbl);
	// incluyo el contenido boton layers
	incluirContenidoBotonLayers();
	
	
    // si es terminal táctil desactivo los eventos de dragging del mapa en el panel del formulario
    if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
    	document.querySelector('.div-layers').addEventListener('touchstart', function () {
    		Mimapa.dragging.disable();
    	}); 
    	document.querySelector('.div-layers').addEventListener('touchend', function () {
    		Mimapa.dragging.enable();
    	});
    } else { // para terminales no táctiles desactivo los listeners del mapa al entrar en el panel del formulario
    	// Disable dragging, scrollWheelZoom and doubleClickZoom when user's cursor enters the element
    	document.querySelector('.div-layers').addEventListener('mouseover', function () {
			Mimapa.dragging.disable();
			Mimapa.scrollWheelZoom.disable();
		});
		// Re-enable dragging, scrollWheelZoom and doubleClickZoom when user's cursor leaves the element
		document.querySelector('.div-layers').addEventListener('mouseout', function () {
			Mimapa.dragging.enable();
			Mimapa.scrollWheelZoom.enable();
		});
    }	
}

// DIBUJAR/SELECCIONAR POLÍGONO
function incluirContenidoBotonPoli() {
	// añado el contenido al control
	document.querySelector(".div-poli").innerHTML = polygonGroupTemplate;
	// quito borde
	document.querySelector(".div-poli").style.border = "none";
	
	// si se abre el collapsible pongo un handler para que lo cierre si se clicka en la página
	const myCollapsible = document.getElementById('sel-polygon');	
	myCollapsible.addEventListener('shown.bs.collapse', event => {
		document.getElementById('mipagina').addEventListener('click', handlerCerrarPoliCollapsible);
		// actualizo aspecto botón (pulsado)
		document.querySelector(".collpoli").style.backgroundColor = "#6c757d";
		document.querySelector(".collpoli span").style.color = "white";
	});
	
	// click en dibujar
	document.getElementById('drawpoli').addEventListener('click', function() {
		// cierro collapsible
		handlerCerrarPoliCollapsible();
		// escondo collapsible y muestro la herramienta de dibujo
		document.querySelector(".div-poli").classList.add("d-none");
		// muestro el control de dibujo
		document.querySelector(".leaflet-draw").classList.remove("d-none");
		// y le hago click()
		document.querySelector(".dibupoli").click();		
	});
	
	// click en upload
	document.getElementById('uploadpoli').addEventListener('click', function() {
		// cierro collapsible
		handlerCerrarPoliCollapsible();
		
		// configuro modal
		configurarModal( { nofooter: true }, //{ static: true, vertcent: true}, 
			getLiteral(dict.uploadPolygon), uploadPolygonTemplate, null);		
		// muestro el modal
		const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
		mimodal.show();
		
		// listener al fichero...
		const iuf = document.getElementById("inputUploadFile");				
		iuf.addEventListener("change", async (event) => {
			if (iuf.files.length == 1) {						
				//console.log("File selected: ", iuf.files[0]);
										
				// detecto si es un shapefile
				const posibleSHP = iuf.files[0].name.toLowerCase().split('.').pop() === "shp";
				//console.log("es SHP? " + posibleSHP);
				const reader = new FileReader();
				reader.onload = async function () {							
					try {
						let migeojson; // declaro mi geojson
						let mibbox; // declaro mi bbox
						let format; // para el logging															
						
						if (posibleSHP) { // CASO SHAPEFILE
							console.debug("Convirtiendo shapefile a GeoJSON...");
							// convierto shapefile a GeoJSON
							migeojson = await shapefile.read(new Uint8Array(reader.result));
							mibbox = migeojson.bbox;
							format = "shapefile";
						}
						else {
							try {
								// CASO GEOJSON
								const mijson = JSON.parse(reader.result);
								console.debug("Usuario subió un GeoJSON");
								if (mijson.type === "FeatureCollection" || mijson.type === "Feature" 
										|| mijson.type === "Polygon" || mijson.type === "MultiPolygon") {
									migeojson = mijson;
									mibbox = bbox(migeojson);
									format = "GeoJSON";
								} 
								else // GEOJSON NO VÁLIDO
									throw new Error("noGeoJSON");
							} catch(err) {
								// CASO WKT
								console.debug("Convirtiendo WKT a GeoJSON...");
								migeojson = parse(reader.result);
								if (!migeojson)
									throw new Error("badGeoJSONorWKT");
								mibbox = bbox(migeojson);
								format = "WKT";
							}
						}								
						// detecto si el CRS es incorrecto
						if (!isBoundingBoxInside(mibbox, config.geoWorldBounds))
							throw new Error("badCRS");
						// detecto si está fuera del mapa
						if (!isBoundingBoxInside(mibbox, config.geoMaxBounds))
							throw new Error("outOfSpain");
							
						// dissolve para crear un único polígono (o multipolígono)
						const midiss = dissolve(migeojson);
						
						// compruebo que sea un polígono o un multipolígono
						if (midiss.type !== "Polygon" && midiss.type !== "MultiPolygon")
							throw new Error("noPolygon");						
						
						// dibujo el polígono
						const migeolayer = L.geoJSON(midiss, {
							style: function (feature) {
								return {
									fillColor: config.colores[config.colregselind][2], // color de relleno  
									weight: 2,
									opacity: 1,
									color: config.colores[config.colregselind][4],
									dashArray: '1',
									fillOpacity: 0.4
								};
							}
						});
						// lo añado a mis polígonos
						migeolayer.addTo(Layers.polis);
						
						// aquí puedo cerrar ya el modal de manera programática
						if (document.getElementById('mimodal').classList.contains('show'))
							mimodal.hide();
						
						// preparo objeto con todo lo necesario para la selección
						const crc = CRC32str(JSON.stringify(midiss));
						//console.warn("CRC: " + crc.toString(16));				
						const mipoliaux = {
							//id : "poli" + nanoid(4),
							id: crc.toString(16),
							geojson: midiss,
							format: format,
							cachear: true								
						};								
						// incluyo poli a la selección
						await incluirPoligonoSP(migeolayer, mipoliaux);
						// navego al polígono
						Mimapa.flyToBounds(migeolayer.getBounds(), {animate: true, duration: 0.4});
					} catch (err) {
						let mens = null;					
						switch (err.message) {
							case "badCRS":
								mens = getLiteral(dict.badCRS);
								break;
							case "outOfSpain":
								mens = getLiteral(dict.outOfSpain);
								break;
							case "badGeoJSONorWKT":
								mens = getLiteral(dict.badGeoJSONorWKT);
								break;
							case "noGeoJSON":
								mens = getLiteral(dict.noGeoJSON);
								break;
							case "noPolygon":
								mens = getLiteral(dict.noPolygon);
								break;
							default:
								mens = getLiteral(dict.unsupportedShape);
								break;
						}
						console.error(mens);
						// reajusto alertas modal
						document.getElementById('wgs84alert').classList.add('d-none');
						document.getElementById('uploadalert').innerHTML = mens;
						document.getElementById('uploadalert').classList.remove('d-none');
					}
				};
				// leo el fichero de manera diferente si es un shp
				if (posibleSHP)
					reader.readAsArrayBuffer(iuf.files[0]); // como binario
				else
					reader.readAsText(iuf.files[0]); // como texto
			}				
		});	
	});
}
function handlerCerrarPoliCollapsible(event) {
    if (!event || !event.target.closest('#collpoli')) {
        // quito este handler
		document.getElementById('mipagina').removeEventListener('click', handlerCerrarPoliCollapsible);
        // cierro el collapsible
        document.querySelector('.collpoli').click();
		// actualizo aspecto botón (sin pulsar)
        document.querySelector('.collpoli').style.backgroundColor = "";
        document.querySelector('.collpoli span').style.color = "";
    }
}

// detecto si está contenido un bounding box (bbeval) en otro (bbref)
function isBoundingBoxInside(bbeval, bbref) {
	const [minLng, minLat, maxLng, maxLat] = bbeval;
	const [ [maxLatRef, minLngRef], [minLatRef, maxLngRef] ] = bbref;
	// Check for valid bounding box
	if (minLng > maxLng || minLat > maxLat) {
		console.error("Invalid bounding box");
		return false;
	}
	return (
		minLat >= minLatRef &&
		maxLat <= maxLatRef &&
		minLng >= minLngRef &&
		maxLng <= maxLngRef
	);
}


// CAPAS DEL MAPA
function incluirContenidoBotonLayers() {
	// añado el contenido al control
	document.querySelector(".div-layers").innerHTML = layerGroupTemplate;
	// quito borde
	document.querySelector(".div-layers").style.border = "none";
	// pongo los checks
	document.getElementById('map-type-' + Sesion.estado.mapType).checked = true;
	document.getElementById('map-details-' + Sesion.estado.mapDetails).checked = true;
	
	// si se abre el collapsible pongo un handler para que lo cierre si se clicka en la página
	const myCollapsible = document.getElementById('sel-layers');	
	myCollapsible.addEventListener('shown.bs.collapse', event => {
		document.getElementById('mipagina').addEventListener('click', handlerCerrarLayerCollapsible);
		// actualizo aspecto botón (pulsado)
		document.querySelector(".layer").style.backgroundColor = "#6c757d";
		document.querySelector(".layer span").style.color = "white";
	});
	
	// pongo listener a los cambios en la capa
	document.querySelectorAll('input[name="mapType"]').forEach(input => {
		input.addEventListener('change', handleLayerChange);
	});
	document.querySelectorAll('input[name="mapDetails"]').forEach(input => {
		input.addEventListener('change', handleLayerChange);
	});
}
function handlerCerrarLayerCollapsible(event) {
    if (!event.target.closest('#sel-layers')) {
        // quito este handler
		document.getElementById('mipagina').removeEventListener('click', handlerCerrarLayerCollapsible);
        // cierro el collapsible
        document.querySelector('.layer').click();
		// actualizo aspecto botón (sin pulsar)
        document.querySelector('.layer').style.backgroundColor = "";
        document.querySelector('.layer span').style.color = "";
    }
}
function handleLayerChange() {	
	// recupero valores
	const newMapDetails = document.querySelector('input[name="mapDetails"]:checked').value;
	const newMapType = document.querySelector('input[name="mapType"]:checked').value;
	
	// detecto cambios y actúo
	if (newMapDetails !== Sesion.estado.mapDetails) {
		Sesion.estado.mapDetails = newMapDetails;
		sendEvent( 'select_content', { content_type: 'map_details_' + Sesion.estado.mapDetails } );
		// repinto las regiones
		repintarRegiones();
	}	
	if (newMapType !== Sesion.estado.mapType) {
		Sesion.estado.mapType = newMapType;
		sendEvent( 'select_content', { content_type: 'map_base_' + Sesion.estado.mapType } );
		// recupero geoconfig previa
		const gcold = obtenerConfigMapaBase();
		// llamo a actualizar el mapa base
		actualizarMapaBase(gcold);
		// reajusto el estilo de las regiones
		ajustarColorRegiones();
	}
    
	// actualizo URL
	history.replaceState(Sesion.estado, "", obtenerURL());
}


// BOTÓN BUSCAR
function incluirContenidoBotonBuscar() {
	// añado el contenido al control
	document.querySelector(".div-buscar").innerHTML = buscarTemplate;
	
	// si se abre el collapsible pongo un handler para que lo cierre si se clicka en el mapa
	const myCollapsible = document.getElementById('buscar_lugares');
	myCollapsible.addEventListener('shown.bs.collapse', event => {
		// pongo el focus en el input
		document.getElementById("in_lugares").focus();
		// listener en el mapa	
		document.getElementById('mimapa').addEventListener('click', handlerCerrarBuscarCollapsible);
        // actualizo aspecto botón (pulsado)
        document.querySelector(".buscar_lugares").setAttribute("style", "background-color: #6c757d;");
        document.querySelector(".buscar_lugares span").setAttribute("style", "color: white;");
	});
}
function handlerCerrarBuscarCollapsible(event) {
    if (!event.target.closest('#buscar_lugares')) {
        // quito este handler
        document.getElementById('mimapa').removeEventListener('click', handlerCerrarBuscarCollapsible);
       // cierro el collapsible
        document.querySelector('.buscar_lugares').click();
        // actualizo aspecto botón (sin pulsar)
        document.querySelector(".buscar_lugares").removeAttribute("style");
        document.querySelector(".buscar_lugares span").removeAttribute("style");
		// si había marcador de municipio, lo quito
		if (Sesion.lugarmarker != null) {
			Sesion.lugarmarker.remove();
			Sesion.lugarmarker = null;
			Sesion.lugar = null;
		}
    }
}



// IDIOMA
function actualizarEtiquetasIdioma() {
	// actualizo título de la página
	document.title = "App - " + getLiteral(dict.title);
	// actualizo etiquetas
	document.getElementById('titulo').innerHTML = getLiteral(dict.title);
	document.getElementById('bot_inicio').setAttribute("title", getLiteral(dict.menu));
	document.querySelector('.home').innerHTML = getLiteral(dict.home);
	document.querySelector('.ifnradio').setAttribute("title", getLiteral(dict.ifnversion));
	document.querySelector('.ifnradio').setAttribute("aria-label", getLiteral(dict.ifnversion));
	document.getElementById('label-ifn2').innerHTML = getLiteral(dict.IFN2);
	document.getElementById('label-ifn3').innerHTML = getLiteral(dict.IFN3);
	document.getElementById('label-ifn4').innerHTML = getLiteral(dict.IFN4);
	document.getElementById('nplotsselected').innerHTML = '#'+getLiteral(dict.plotsSelected)+':';
	document.getElementById('botdescargar').innerHTML = getLiteral(dict.download);
	document.getElementById('bot_taxones').innerHTML = getLiteral(dict.taxonfilter);
	document.getElementById('in_lugares').setAttribute("placeholder", getLiteral(dict.searchplace));
	document.getElementById('in_lugares').setAttribute("aria-label", getLiteral(dict.searchplace));
	document.querySelector('.buscar_lugares').setAttribute("title", getLiteral(dict.searchplace));
	document.querySelector('.layer').setAttribute("title", getLiteral(dict.selectLayer));
	document.getElementById('drawpoli').innerHTML = '<i class="bi bi-pencil-fill"></i> ' + getLiteral(dict.draw);
	document.getElementById('uploadpoli').innerHTML = '<i class="bi bi-file-earmark-arrow-up-fill"></i> ' + getLiteral(dict.upload);
	document.querySelector('.collpoli').setAttribute("title", getLiteral(dict.createPolygon));
	document.querySelector('.leaflet-control-zoom-in').setAttribute("title", getLiteral(dict.zoomin));
	document.querySelector('.leaflet-control-zoom-out').setAttribute("title", getLiteral(dict.zoomout));
	document.getElementById('labchecknomci').setAttribute("title", getLiteral(dict.nomci));
	
	// cierro bot_taxones e inicializo a "" el navegador de taxones
	if (document.getElementById('bot_taxones').classList.contains('active')) 
		document.getElementById('bot_taxones').click();
	document.getElementById('taxones_block').innerHTML = "";
	document.getElementById('taxones_block').classList.add('d-none');	
	
	// actualizamos etiquetas Leaflet Draw
	actualizarEtiquetasLDraw();
}

// etiquetas Leaflet.Draw
function actualizarEtiquetasLDraw() {
	//$(".leaflet-draw-draw-polygon").attr("title", getLiteral(dict.downloadData));
	document.querySelector(".leaflet-draw-draw-polygon").setAttribute("title", getLiteral(dict.drawPolygon));
	L.drawLocal.draw.toolbar.actions.text = getLiteral(dict.cancel);
	L.drawLocal.draw.toolbar.actions.title = getLiteral(dict.cancelPolygon);
	L.drawLocal.draw.toolbar.finish.text = getLiteral(dict.finish);
	L.drawLocal.draw.toolbar.finish.title = getLiteral(dict.finishPolygon);
	L.drawLocal.draw.toolbar.undo.text = getLiteral(dict.deleteLastPoint);
	L.drawLocal.draw.toolbar.undo.title = getLiteral(dict.deleteLastPointDrawn);
	L.drawLocal.draw.toolbar.buttons.polygon = getLiteral(dict.drawPolygon);
	L.drawLocal.draw.handlers.polygon.tooltip.start = getLiteral(dict.startPolygon);
	L.drawLocal.draw.handlers.polygon.tooltip.cont = getLiteral(dict.contPolygon);
	L.drawLocal.draw.handlers.polygon.tooltip.end = getLiteral(dict.endPolygon);
	L.drawLocal.draw.handlers.polyline.error = getLiteral(dict.errorPolygon);
	drawControl.options.draw.polygon.drawError.message = getLiteral(dict.errorPolygon);
}

export { cargarPaginaPrincipal, cargarBotonesMapa };